import { render, staticRenderFns } from "./LeakageRate.vue?vue&type=template&id=6c95dad0&scoped=true"
import script from "./LeakageRate.vue?vue&type=script&lang=js"
export * from "./LeakageRate.vue?vue&type=script&lang=js"
import style0 from "./LeakageRate.vue?vue&type=style&index=0&id=6c95dad0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c95dad0",
  null
  
)

export default component.exports